module.exports = __webpack_public_path__ + "img/logo-footer.bf0435bc.png";